import LibraryCommonList from "./components/LibraryCommonList/LibraryCommonList";
import PagePanel from "./../../../components/page/PagePanel/PagePanel";
import { Component } from "react";
import "./LibraryCommonListPanel.css";
import TalaeraSpinner from "../../TalaeraSpinner/TalaeraSpinner";
import { TranslatedComponent } from "hooks/useTranslation";
import SpeakingClubBanner from "components/SpeakingClubBanner";
import FinishSetup from "./components/FinishSetup";

export class LibraryCommonListTypes {
  static FOLDER = "folder";
  static OBJECT = "object";
}

export default class LibraryCommonListPanel extends Component {
  render() {
    const {
      data,
      rootData,
      dataLoading,
      rootDataLoading,
      progressPage,
      onMoreProgressData,
      onSetupClick,
      user,
    } = this.props;

    const folderList = data?.list ?? [];
    const rootList = rootData?.list ?? [];

    return (
      <TranslatedComponent>
        {({ t }) => (
          <div className="library-common-list-panel">
            {dataLoading && (
              <div className="data-loader spinner-container">
                <TalaeraSpinner />
              </div>
            )}

            {!dataLoading && folderList.length > 0 && (
              <PagePanel
                title={<div>{t("Library.InProgress")}</div>}
                noBorder
                className="library-panel"
              >
                <LibraryCommonList
                  sectionIndex={0}
                  objects={folderList}
                  isSlide
                  isProgress
                  totalCount={data?.total}
                  type={LibraryCommonListTypes.OBJECT}
                  fetchMore={onMoreProgressData}
                  page={progressPage}
                />
              </PagePanel>
            )}

            {rootDataLoading && (
              <div className="data-loader spinner-container">
                <TalaeraSpinner />
              </div>
            )}

            {!rootDataLoading && (
              <PagePanel
                title={<div>{t("Library.Recommended")}</div>}
                noBorder
                className="library-panel"
              >
                {user?.student?.has_all_onboarding_data && rootList.length > 0 && (
                  <LibraryCommonList
                    sectionIndex={1}
                    isSlide
                    objects={rootList}
                    type={LibraryCommonListTypes.OBJECT}
                  />
                )}

                {user?.student?.has_all_onboarding_data === false && (
                  <FinishSetup onClick={onSetupClick} />
                )}
              </PagePanel>
            )}

            <SpeakingClubBanner />
          </div>
        )}
      </TranslatedComponent>
    );
  }
}
